import { CurrencyCode } from '@omnea-app/packages/universal/currency-utils/getCurrencyCodes'

type Input = {
  value?: string | null | number
  defaultCurrency?: CurrencyCode
}

export const formatPriceValue = ({ defaultCurrency, value }: Input): string => {
  if (defaultCurrency == null || value == null) return value != null ? String(value) : ''
  if (typeof value !== 'string') return `${defaultCurrency} ${value}`

  // Format either:
  // - "20 / 30"
  // - "Term 1: 20 / 30 | Term 2: 10"
  return (value as string)
    .split(' | ')
    .map((termPart) => {
      const [maybeLabel, maybeAmounts] = termPart.includes(': ')
        ? (termPart.split(/:\s(.+)/) as [string, string]) // split once
        : [null, termPart]

      const formattedAmounts = (maybeAmounts ?? termPart)
        .split(' / ')
        .map((v) => `${defaultCurrency} ${v.trim()}`)
        .join(' / ')

      return maybeLabel != null ? `${maybeLabel}: ${formattedAmounts}` : formattedAmounts
    })
    .join(' | ')
}
